import Button from "@mui/material/Button";
import MUIPagination from "@mui/material/Pagination";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React from "react";

interface Props {
    rowCount: number;
    pageCount: number;
    currentPage: number;
    currentPageSize: number;
    pageSizeOptions: number[];
    onNavigateToPage: (newPage: number) => void;
    onChangePageSize: (newSize: number) => void;
    createResultString: (first: number, last: number, total: number) => string;
    readonly?: boolean;
    testId?: string;
}

const useStyles = makeStyles(() => ({
    tableNavigation: {
        display: "flex",
        justifyContent: "space-between",
        fontSize: "0.8rem"
    },
    pageSize: {
        placeSelf: "center",
        position: "absolute",
        left: "16px",
        fontWeight: "500"
    },
    pageSizeButton: {
        minWidth: 0,
        padding: "0px 2px"
    },
    pageSizeButtonActive: {
        color: "black",
        fontWeight: "bold",
        padding: "0px 4px",
        backgroundColor: "rgba(0, 0, 0, 0.1)"
    },
    pageSizeDot: {
        fontWeight: "bold",
        margin: "0px 2px"
    },
    pagination: {
        display: "flex",
        margin: "0px 24px",
        minWidth: "350px",
        justifyContent: "center"
    },
    resultCount: {
        placeSelf: "center",
        position: "absolute",
        right: "16px",
        fontWeight: 500,
        fontSize: "0.8rem",
        color: "rgba(0,0,0,0.87)"
    }
}));

const QAPagination: React.FC<Props> = props => {
    const classes = useStyles();

    return (
        <div className={classes.tableNavigation}>

            <div className={classes.pageSize}>
                {!props.readonly && props.pageSizeOptions.map((size, index) => (
                    <React.Fragment key={index}>
                        {index > 0 && (
                            <span className={classes.pageSizeDot} key={index}>&middot;</span>
                        )}
                        <Button
                            key={size}
                            className={clsx(classes.pageSizeButton, size === props.currentPageSize && classes.pageSizeButtonActive)}
                            data-cy={`${props.testId}-Button-Size-${size}`}
                            variant="text"
                            color="primary"
                            size="small"
                            onClick={() => props.onChangePageSize(size)}>
                            {size}
                        </Button>
                    </React.Fragment>
                ))}
                {!props.readonly && " pro Seite"}
            </div>

            {!props.readonly && props.pageCount > 0 && (
                <MUIPagination
                    data-cy={`${props.testId}-Navigation`}
                    className={classes.pagination}
                    count={props.pageCount}
                    color="primary"
                    shape="rounded"
                    page={props.currentPage + 1}
                    onChange={(_, page) => props.onNavigateToPage(page - 1)} />
            )}

            {(props.readonly || props.pageCount === 0) && (
                <div className={classes.pagination} />
            )}

            <span
                data-cy={`${props.testId}-Count`}
                className={classes.resultCount}>
                {props.createResultString(
                    Math.min(props.rowCount, props.currentPage * props.currentPageSize + 1),
                    Math.min((props.currentPage + 1) * props.currentPageSize, props.rowCount),
                    props.rowCount
                )}
            </span>

        </div>
    );
};

export default QAPagination;
